import request from '@/router/axios';

export const getList = (current, size, params) => {
    return request({
        url: '/api/sino-columnBulletin/columnBulletin/list',
        method: 'get',
        params: {
            ...params,
            current,
            size,
        }
    })
}


export const getCmsList = (current, size, params) => {
    return request({
        url: '/api/sino-columnBulletin/columnBulletin/cmsList',
        method: 'get',
        params: {
            ...params,
            current,
            size,
        }
    })
}

export const getDetail = (id) => {
    return request({
        url: '/api/sino-columnBulletin/columnBulletin/detail',
        method: 'get',
        params: {
            id
        }
    })
}

export const remove = (ids) => {
    return request({
        url: '/api/sino-columnBulletin/columnBulletin/remove',
        method: 'post',
        params: {
            ids,
        }
    })
}

export const add = (row) => {
    return request({
        url: '/api/sino-columnBulletin/columnBulletin/submit',
        method: 'post',
        data: row
    })
}

export const update = (row) => {
    return request({
        url: '/api/sino-columnBulletin/columnBulletin/submit',
        method: 'post',
        data: row
    })
}

export const publish = (row) => {
    return request({
        url: '/api/sino-columnBulletin/columnBulletin/publish',
        method: 'post',
        data: row
    })
}

